/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OtherRelative/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import Separator from './Separator/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function OtherRelative({
  children,
  viewPath = "/DesignSystem/PatientOverview/Content/OtherRelatives/Content/OtherRelative"
  
}) {
let otherRelativeFromPersonRecordFirstNameValueData = fromData.useDataValue({ viewPath,
context: 'other_relative',
path: 'from_person_record.first_name',
})
let constantData = ' ('
let otherRelativeTypeValueData = fromData.useDataFormat({ viewPath,
context: 'other_relative',
path: 'type',
format: fromFormat.capitalize,
})
let constantData1 = ')'
let aggregateData = fromAggregate.joinNoSpace(otherRelativeFromPersonRecordFirstNameValueData, constantData, otherRelativeTypeValueData, constantData1)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="other_relative.from_person_record.first_name"
 data="' ('"
 data="other_relative.type"
 format="/Data/format.js capitalize"
 data="')'"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
<Separator
  viewPath={`${viewPath}/Separator`}
/>
{children}
</React.Fragment>)
}